import "./ChildStatsRow.scss";
import energyIcon from "../../assets/images/Battery-0.svg";
import { getPhonicResults } from "../../utils/gameUtils";
import { setEnergyToFull } from "../../api/userService";
import { useState } from "react";
import { Link } from "react-router-dom";

const ChildStatsRow = ({ child }) => {
  const phonicResults = getPhonicResults(child.roundsPlayed);
  const [energyLevel, setEnergyLevel] = useState(child.energyLevel);

  return (
    <tbody>
      <tr className="child-stats-row">
        <td className="child-stats-row__cell">
          <Link to="/stats-page" state={child}>
            <img
              className="child-stats-row__avatar"
              src={child.avatar}
              alt="avatar"
            />
          </Link>
        </td>
        <td className="child-stats-row__cell child-stats-row__cell--name">
          {child.childName}
        </td>
        <td className="child-stats-row__cell">{phonicResults?.topPhonic}</td>
        <td className="child-stats-row__cell">{phonicResults?.mostImproved}</td>
        <td className="child-stats-row__cell">{phonicResults?.bottomPhonic}</td>
        <td className="child-stats-row__cell child-stats-row__cell--name">
          {child.parent?.name}
        </td>
        <td className="child-stats-row__cell">{child.parent?.email}</td>
        <td className="child-stats-row__cell">{energyLevel}</td>
        <td>
          <button
            onClick={() => {
              setEnergyToFull(child.uid); // Update the remote database
              setEnergyLevel(100); // Update the local state
            }}
            className="child-stats-row__button"
          >
            <img src={energyIcon} alt="Energy level recharge button" />
          </button>
        </td>
      </tr>
    </tbody>
  );
};

export default ChildStatsRow;
